<ui-radio-group [ngModel]="selected" (ngModelChange)="valueChange($event)">
  <label *ngFor="let option of options" [uiValue]="option.value" ui-radio>{{ option.text }}</label>
</ui-radio-group>
